module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('h2', [_vm._v("All Transmitters\n\t\t\t\t"), _c('i', {
    staticClass: "fa fa-refresh fa-fw",
    class: {
      'fa-spin': _vm.running
    },
    on: {
      "click": _vm.loadData
    }
  })]), _vm._v(" "), _c('info-error', {
    attrs: {
      "message": _vm.errorMessage
    }
  }), _vm._v(" "), (_vm.table.rows) ? _c('tablegrid', {
    attrs: {
      "columns": _vm.table.columns,
      "data": _vm.table.rows,
      "mail-action": _vm.mailToOwner,
      "edit-action": _vm.editElement,
      "delete-action": _vm.deleteElement
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "actions well"
  }, [(this.$store.getters.user.admin) ? [_c('legend', [_vm._v("Actions")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/transmitters/new"
    }
  }, [_vm._v("New Transmitter")])], 1), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "linklike",
    on: {
      "click": _vm.mailToAll
    }
  }, [_vm._v("Send a mail to all owners")])])]), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.table.rows) ? [_c('legend', [_vm._v("Statistics")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Total Transmitters")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.statTotal))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('chart-online-offline', {
    attrs: {
      "chartData": _vm.chartData
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('chart-transmitter-types', {
    attrs: {
      "chartData": _vm.chartDataDeviceTypes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.widerangeOnly),
      expression: "settings.widerangeOnly"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.widerangeOnly) ? _vm._i(_vm.settings.widerangeOnly, null) > -1 : (_vm.settings.widerangeOnly)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.settings.widerangeOnly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.settings.widerangeOnly = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.settings.widerangeOnly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settings.widerangeOnly = $$c
        }
      }
    }
  }), _vm._v(" Show Widerange-transmitter only")])])] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Transmitters")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6691aa2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/transmitter/Overview.vue
// module id = 623
// module chunks = 1